import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { tap } from 'rxjs/operators';
import { IdentityService } from '../identity.service';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[ifLogged]' })
export class IfLoggedDirective {
  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private identityService: IdentityService
  ) {
    this.identityService.isLogged$
      .pipe(
        tap(() => this.viewContainer.clear())
      )
      .subscribe(isLogged => {
        if (isLogged) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
}
